// extracted by mini-css-extract-plugin
export default {"container":"ModularConfiguratorSection__container___xc6ty","inner":"ModularConfiguratorSection__inner___y1aY3","content":"ModularConfiguratorSection__content___fZRej"};